<l-list-container
  class="categories-list-table"
  [size]="limit"
  [page]="page"
  [data]="data"
  [sort]="sort"
  [total]="total"
  [isLoading]="isLoading"
  (onPage)="pageChange.emit($event)"
  (onSort)="sortChange.emit($event)"
>
  <ng-template #header>
    <th lSortable="name">Nome</th>
    <th lSortable="description">Descrição</th>
    <th lSortable="color">Cor</th>
    <th lSortable="createdAt">Criado em</th>
    <th lSortable="updatedAt">Última atualização</th>
    <th class="w-12"></th>
  </ng-template>

  <ng-template #body let-category>
    <td class="align-top">
      <span class="font-medium text-lWhite">{{ category.name }}</span>
    </td>

    <td class="align-top">
      <span class="block max-w-[460px] text-sm leading-5 text-lGray300">
        {{ category.description || '—' }}
      </span>
    </td>

    <td class="align-top">
      <span
        class="inline-flex h-6 w-8 rounded-full"
        [style.background]="category.color || '#5B55FF'"
        aria-label="Cor da categoria"
      ></span>
    </td>

    <td class="align-top">{{ category.createdAt ? (category.createdAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td class="align-top">{{ category.updatedAt ? (category.updatedAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td class="align-top">
      <button
        class="flex h-7 w-7 items-center justify-center rounded text-lGray600 transition-colors hover:bg-lGray700/70 hover:text-lWhite"
        (click)="rowMenu.toggle($event)"
      >
        <l-icon icon="more_vert" />
      </button>

      <l-modal-actions #rowMenu [actions]="getRowActions(category)" />
    </td>
  </ng-template>
</l-list-container>
